import { defineStore } from 'pinia'
import { computed } from 'vue'
import type { Permission } from '@/auth/permissions'
import { useAuthStore } from './auth.store'

/**
 * Reads the user's permissions directly from auth.user.permissions
 * (sent by the backend). The frontend never derives the list itself.
 */
export const usePermissionsStore = defineStore('permissions', () => {
  const auth = useAuthStore()

  const permissions = computed<Set<Permission>>(
    () => new Set<Permission>((auth.user?.permissions ?? []) as Permission[]),
  )

  const list = computed<Permission[]>(() => Array.from(permissions.value))

  return { permissions, list }
})
